<script>
    import 'whatwg-fetch'
    import {onMount} from 'svelte';
    import BarChart from './BarChart.svelte';
    import PieChart from './PieChart.svelte';
    import SingleNumberChart from './SingleNumberChart.svelte';
    import Login from "./Login.svelte";
    import Cookies from '../public/vendor/js-cookie/js.cookie'

    import fetchIntercept from 'fetch-intercept';
    import Common from "../public/lib/common";

    let logged = false;

    let data = {};

    let pieChart;
    let illnessPieChart;
    let sexPieChart;
    let bmiChart;

    /**
     * Fetch interceptor
     */
    fetchIntercept.register({
        request: function (url, config) {
            const withDefaults = Object.assign({}, config);
            withDefaults.headers = withDefaults.headers || new Headers({
                'UUID': Cookies.get('uuid')
            });
            return [url, withDefaults];
        },

        requestError: function (error) {
            return Promise.reject(error);
        },

        response: function (response) {
            return response;
        },

        responseError: function (error) {
            return Promise.reject(error);
        }
    });

    let pieChartData = {
        labelsData: ["18-20", "21-30", "31-40", "41-50", "51-60", "61-70", "71-100"],
        valuesData: [19, 94, 85, 48, 16, 13, 1],
        titleData: 'Wiek ochotników'
    };

    let sexPieChartData = {
        labelsData: ["Kobiety", "Mężczyźni"],
        valuesData: [1, 1],
        titleData: 'Płeć ochotników',
        colorsData: ["#b2d235", "#f26921"]
    };

    let illnessPieChartData = {
        labelsData: ["Zdrowi", "Chorzy"],
        valuesData: [266, 10],
        titleData: 'Choroby ochotników'
    };

    let bmiPieChartData = {
        labelsData: ["<18", "18-28", "28-30", ">30"],
        valuesData: [3, 223, 22, 28],
        titleData: 'BMI ochotników'
    };

    const barChartData = {
        labelsData: [],
        valuesData: [],
        titleData: 'Ilość rejestracji ochotników'
    };

    var extractInternalChartData = function (data) {
        for (const key in data) {
            return data[key];
        }
    };

    var originalDoughnutDraw = Chart.controllers.doughnut.prototype.draw;
    Chart.helpers.extend(Chart.controllers.doughnut.prototype, {
        draw: function () {
            originalDoughnutDraw.apply(this, arguments);

            var chart = this.chart.chart;
            var ctx = chart.ctx;

            ctx.imageSmoothingEnabled = true;
            var width = chart.width;
            var height = chart.height;

            var fontSize = (height / 200).toFixed(2);
            ctx.font = fontSize + "em Verdana";
            ctx.textBaseline = "middle";

            let sum = 0;
            for (var i = 0; i < chart.config.data.datasets[0].data.length; i++) {
                sum += chart.config.data.datasets[0].data[i];
                if (chart.config.data &&
                        chart.config.data.datasets[0]._meta) {
                    var internalData = extractInternalChartData(chart.config.data.datasets[0]._meta);
                    if (internalData && internalData.data && internalData.data[i] && internalData.data[i].hidden) {
                        sum -= chart.config.data.datasets[0].data[i];
                    }
                }
            }

            var text = sum,
                    textX = Math.round((width - ctx.measureText(text).width) / 2),
                    textY = height / 2 + 40;

            ctx.fillText(text, textX, textY);
        }
    });

    onMount(async () => {
        let x = Cookies.get('uuid');
        if (x) {
            setLoggedIn(x);
        }
    });

    function setupData() {
        barChartData.labelsData = Array(data.participantRegistration.length);
        barChartData.valuesData = Array(data.participantRegistration.length);
        data.participantRegistration.forEach(function printElt(element, index) {
            barChartData.labelsData[index] = element.text;
            barChartData.valuesData[index] = element.value;
        });

        sexPieChartData.valuesData = [data.sexChart.find(o => {
            return o.text == "MALE"
        }).value, data.sexChart.find(o => {
            return o.text == "FEMALE"
        }).value];
        sexPieChart.setup(sexPieChartData);


        illnessPieChartData.valuesData = [
            data.illnessChart.find(o => {return o.text == "FALSE"}).value,
            data.illnessChart.find(o => {return o.text == "TRUE"}).value
        ];
        illnessPieChart.setup(illnessPieChartData);

        pieChartData.valuesData = [
            data.ageChart.find(o => {return o.text == "18-20"}).value,
            data.ageChart.find(o => {return o.text == "21-30"}).value,
            data.ageChart.find(o => {return o.text == "31-40"}).value,
            data.ageChart.find(o => {return o.text == "41-50"}).value,
            data.ageChart.find(o => {return o.text == "51-60"}).value,
            data.ageChart.find(o => {return o.text == "61-70"}).value,
            data.ageChart.find(o => {return o.text == "71-100"}).value
        ];
        pieChart.setup(pieChartData);

        bmiPieChartData.valuesData = [
            data.bmiChart.find(o => {return o.text == "<18"}).value,
            data.bmiChart.find(o => {return o.text == "18-28"}).value,
            data.bmiChart.find(o => {return o.text == "28-30"}).value,
            data.bmiChart.find(o => {return o.text == ">30"}).value
        ];
        bmiChart.setup(bmiPieChartData);

    }

    function setLoggedIn(uuid) {
        logged = true;
        Cookies.set('uuid', uuid);
        Common.getStats().then(function (response) {
            data = response;
            setupData();
        }).catch(function (present) {
            Cookies.set('uuid', null);
            logged = false;
        });
    }

    function loggedIn(event) {
        setLoggedIn(event.detail.uuid);
    }

</script>

<main style="min-height: 100%" class="flex justify-center">
    {#if logged}
        <div class="container-fluid">
            <div class="row">
                <div class="col-6 col-lg-3 mt-4">
                    <SingleNumberChart number="{data.participantsCount}" title="Ilość ochotników"></SingleNumberChart>
                </div>
                <div class="col-6 col-lg-3 mt-4">
                    <SingleNumberChart number="{data.applicationsCount}"
                                       title="Ilość zgłoszeń w Badaneo"></SingleNumberChart>
                </div>
                <div class="col-6 col-lg-3 mt-4">
                    <SingleNumberChart number="{data.researchCount}" title="Ilość aktywnych badań"></SingleNumberChart>
                </div>
                <div class="col-6 col-lg-3 mt-4">
                    <SingleNumberChart number="{data.doctorsCount}" title="Ilość lekarzy"></SingleNumberChart>
                </div>
            </div>
            <div class="row">
                <div class="col-12 mt-4">
                    <BarChart {...barChartData}/>
                </div>
            </div>
            <div class="row">
                <div class="col-12 col-lg-6 mt-4">
                    <PieChart bind:this={pieChart}/>
                </div>
                <div class="col-12 col-lg-6 mt-4">
                    <PieChart bind:this={sexPieChart}/>
                </div>
            </div>
            <div class="row">
                <div class="col-12 col-lg-6 mt-4">
                    <PieChart bind:this={illnessPieChart}/>
                </div>
                <div class="col-12 col-lg-6 mt-4">
                    <PieChart bind:this={bmiChart}/>
                </div>
            </div>
        </div>
    {:else}
        <Login on:logged={loggedIn}/>
    {/if}
</main>

<style>

</style>
